module.exports = __webpack_public_path__ + "img/space_dust_grape_front.887e7e57.jpg";